import {Dispatch, FC, SetStateAction, useEffect, useState} from 'react'
import {KTIcon} from '../../../../../../_metronic/helpers'
import {InvoiceExcelModalHeader} from './InvoiceExcelModalHeader'
import {InvoiceExcelModalBody} from './InvoiceExcelModalBody'

type props = {
  invoiceType: {
    invoiceType: number
    setInvoiceType: Dispatch<SetStateAction<number>>
  }
  invoiceTemplate: {
    invoiceTemplate: number
    setInvoiceTemplate: Dispatch<SetStateAction<number>>
  }
  title: {
    title: string
    setTitle: Dispatch<SetStateAction<string>>
  }
  action: {
    excelModal: boolean
    setExcelModal: React.Dispatch<React.SetStateAction<boolean>>
  }
}
const InvoiceExcelModal: FC<props> = ({action, invoiceType, invoiceTemplate, title}) => {
  useEffect(() => {
    document.body.classList.add('modal-open')
    return () => {
      document.body.classList.remove('modal-open')
      invoiceType.setInvoiceType(0)
      invoiceTemplate.setInvoiceTemplate(0)
      title.setTitle('')
    }
  }, [])

  return (
    <>
      <div
        className='modal fade show d-block'
        id='kt_modal_add_invoice'
        role='dialog'
        tabIndex={-1}
        aria-modal='true'
      >
        {/* begin::Modal dialog */}
        {/* The body scrolls under a fixed header (509): at 768 the whole 2,495px dialog scrolled with the page
            and took the close button with it. Full screen below 768, as it was below 576. */}
        <div
          className='modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl modal-fullscreen-md-down'
          style={{minWidth: '75%'}}
        >
          {/* begin::Modal content */}
          <div className='modal-content'>
            <InvoiceExcelModalHeader title={title.title} action={action} />
            {/* begin::Modal body */}
            <div className='modal-body scroll-y mx-0 mx-sm-5 mx-xl-15 my-3 my-sm-7 text-center'>
              <InvoiceExcelModalBody
                action={action}
                title={title}
                invoiceType={invoiceType}
                invoiceTemplate={invoiceTemplate}
              />
            </div>
            {/* end::Modal body */}
          </div>
          {/* end::Modal content */}
        </div>
        {/* end::Modal dialog */}
      </div>
      {/* begin::Modal Backdrop */}
      <div className='modal-backdrop fade show'></div>
      {/* end::Modal Backdrop */}
    </>
  )
}

export {InvoiceExcelModal}
